import styled, { css } from "styled-components";
import { TextButton } from "../textButton";

export const PrivacyPolicyButton = styled(TextButton)(({ theme }) => css`
  font-weight: ${theme.fonts.headingWeight};
  font-size: 16px;
`);